var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-button',{attrs:{"type":"border","icon-pack":"feather","icon":"icon-corner-left-down"},on:{"click":function($event){return _vm.$emit('selectGoal')}}},[_vm._v("Assign Goals ("+_vm._s(this.selectGoalEnabled)+")")])
}
var staticRenderFns = []

export { render, staticRenderFns }